// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-infinite-scroll--horizontal {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}
:where(.vuetify-styles) .v-infinite-scroll--horizontal .v-infinite-scroll-intersect {
  height: 100%;
  width: var(--v-infinite-margin-size, 1px);
}

:where(.vuetify-styles) .v-infinite-scroll--vertical {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
:where(.vuetify-styles) .v-infinite-scroll--vertical .v-infinite-scroll-intersect {
  height: 1px;
  width: 100%;
}

:where(.vuetify-styles) .v-infinite-scroll-intersect {
  overflow: hidden;
  pointer-events: none;
  margin-top: var(--v-infinite-margin);
  margin-bottom: calc(var(--v-infinite-margin) * -1);
}
:where(.vuetify-styles) .v-infinite-scroll-intersect:nth-child(2) {
  --v-infinite-margin: var(--v-infinite-margin-size, 1px);
}
:where(.vuetify-styles) .v-infinite-scroll-intersect:nth-last-child(2) {
  --v-infinite-margin: calc(var(--v-infinite-margin-size, 1px) * -1);
}

:where(.vuetify-styles) .v-infinite-scroll__side {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 8px;
  transition-property: padding;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-infinite-scroll__side:empty, :where(.vuetify-styles) .v-infinite-scroll__side:has(> div:only-child:empty) {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VInfiniteScroll/VInfiniteScroll.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,kDAAkD;AACpD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ","sourcesContent":[".v-infinite-scroll--horizontal {\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n}\n.v-infinite-scroll--horizontal .v-infinite-scroll-intersect {\n  height: 100%;\n  width: var(--v-infinite-margin-size, 1px);\n}\n\n.v-infinite-scroll--vertical {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n.v-infinite-scroll--vertical .v-infinite-scroll-intersect {\n  height: 1px;\n  width: 100%;\n}\n\n.v-infinite-scroll-intersect {\n  overflow: hidden;\n  pointer-events: none;\n  margin-top: var(--v-infinite-margin);\n  margin-bottom: calc(var(--v-infinite-margin) * -1);\n}\n.v-infinite-scroll-intersect:nth-child(2) {\n  --v-infinite-margin: var(--v-infinite-margin-size, 1px);\n}\n.v-infinite-scroll-intersect:nth-last-child(2) {\n  --v-infinite-margin: calc(var(--v-infinite-margin-size, 1px) * -1);\n}\n\n.v-infinite-scroll__side {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 8px;\n  transition-property: padding;\n  transition-duration: 0.3s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-infinite-scroll__side:empty, .v-infinite-scroll__side:has(> div:only-child:empty) {\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
